export const SET_OWN_SERIES = 'SET_OWN_SERIES'
export const SET_MANAGE_SERIES = 'SET_MANAGE_SERIES'
export const CLEAR_MANAGE_SERIES = 'CLEAR_MANAGE_SERIES'
export const UPDATE_MANAGE_SERIES = 'UPDATE_MANAGE_SERIES'
export const SET_MANAGE_SECTION = 'SET_MANAGE_SECTION'
export const SET_CONTACT_FORM = 'SET_CONTACT_FORM'

export enum ManageSection {
  LEGAL = 'legal',
  PLUGINS = 'plugins',
  MANAGE = 'manage',
  DOCKING = 'docking',
}

export enum Badges {
  CONTROLLER = 'Controller',
  FIRST = 'First Member',
  MANAGEMENT = 'Manager',
  SIGNER = 'msg Member',
  TOKENMEMBER = 'tkn Member',
  TOKENMANAGER = 'tkn Manager',
  CLOSED = 'Closed',
}

export const enum PluginIcon {
  BOX = 'box',
  GLOBE = 'globe',
  GRAPHUP = 'graphup',
  MINTTOKEN = 'minttoken',
  SIGNDOC = 'signdoc',
  TOKENIZE = 'tokenize',
  WALLET = 'wallet',
  SHARES = 'tokenizeShares',
  GEAR = 'gear',
  CHAINCLOSED = 'chainclosed',
  ARROWUPDOWN = 'arrowupdown'
}

export type StampData = {
  entity: string
  address: string
  link: string
  filename: string
}

export type SeriesType = {
  tokenId: number
  name: string
  jurisdiction: string
  jurisdictionIndex: number
  created: Date
  renewal?: Date
  owner: string
  ownerType: string
  first: string
  closed: boolean
  badges: Badges[]
  image: string
  access: boolean
  sharesContract?: string
}

interface SetOwnSeries {
  type: typeof SET_OWN_SERIES
  payload: SeriesType[]
}
interface SetManageSeries {
  type: typeof SET_MANAGE_SERIES
  payload: SeriesType
}
interface ClearManageSeries {
  type: typeof CLEAR_MANAGE_SERIES
}
interface UpdateManageSeries {
  type: typeof UPDATE_MANAGE_SERIES
  payload: string | undefined
}
interface SetManageSection {
  type: typeof SET_MANAGE_SECTION
  payload: { section?: string; sectionParam?: any; subSection?: number }
}
interface SetContactForm {
  type: typeof SET_CONTACT_FORM
  payload: boolean
}
export interface IManagementState {
  series: SeriesType[]
  managing?: SeriesType
  contactForm: boolean
  section?: string
  update?: string
  sectionParam?: any
  subSection?: number
}

export type ManagementActionTypes =
  | SetOwnSeries
  | SetManageSeries
  | ClearManageSeries
  | UpdateManageSeries
  | SetManageSection
  | SetContactForm
